export default ({
    apiUrl: 'https://czqcb2vlae.execute-api.eu-north-1.amazonaws.com/Prod',
    openApiUrl: 'https://hj9vua12al.execute-api.eu-north-1.amazonaws.com/Prod',
})